import './ContextInsights.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContextInsightsType } from './types/ContextInsightsType';
import StackedHorizontalBarChart from '../../../../shared/components/chart/stacked-horizontal-bar-chart/StackedHorizontalBarChart';

interface ContextInsightsProps {
  contextInsights: ContextInsightsType | null;
}

const ContextInsights: React.FC<ContextInsightsProps> = ({ contextInsights }) => {
  const { t } = useTranslation();

  if (!contextInsights) {
    return <></>;
  }

  return (
    <>
      <div className="stats context-insights">
        <div className="stats__panel">
          <div className="page-box__title-action">
            <div className="page-box__title page-box__title--flex">
              {t('insightPage.contextInsights')}
            </div>
          </div>
          <div className="stats-box">
            <div className="stats-box__content stats-box__content--sentiment">
              <div className="stats-box__icon">
                <span
                  className={`ico--${contextInsights.sentimentAnalysis.type.toLowerCase()} ico--lg`}
                />
              </div>
              <div className="stats-box__sentiment-box">
                <div className="stats-box__status stats-box__status--positive">Positive</div>
                <div className="stats-box__desc">{contextInsights.sentimentAnalysis.justification}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="stats__panel stats__panel--margin-top">
          <div className="stats-box">
            <div className="stats-box__content">
              <div className="stats-box__title">Brand Strengths</div>
              <StackedHorizontalBarChart data={[{ label: 'Shoper', value: 70.2, color: '#45A987' }]} showLegend={false}/>
              <div className="stats-box__desc">{contextInsights.brandStrengths}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="stats stats--three-cols">
        <div className="stats-box">
          <div className="stats-box__content">
            <div className="stats-box__title">Brand Attributes per LLM</div>
            <div className="stats-box__desc">{contextInsights.brandAttributesPerLlm}</div>
          </div>
        </div>
        <div className="stats-box">
          <div className="stats-box__content">
            <div className="stats-box__title">Topics with sources</div>
            <div className="stats-box__desc">{contextInsights.topicsWithSources}</div>
          </div>
        </div>
        <div className="stats-box">
          <div className="stats-box__content">
            <div className="stats-box__title">Share of answer</div>
            <div className="stats-box__desc">{contextInsights.shareOfAnswer}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContextInsights;
